import { useAuth } from '@/context/AuthContext';
import { useState, useEffect } from "react";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import * as Sentry from '@sentry/react';

const DailyCheckList = () => {
    const { apiFetch, user } = useAuth();
    const [checklistData, setChecklistData] = useState([]);
    const [allProperties, setAllProperties] = useState([]);

    const fetchChecklistData = async () => {
        const userID = user.userID;
        try {
            const response = await apiFetch(`/api/Ops/daily-checklist/submissions-by-user?userID=${userID}`);
            const data = await response.json();
            if (data.success && data.data) {
                setChecklistData(data.data);
            }
        } catch (e) {
            Sentry.captureException(e);
            console.error(e);
        }
    }

    const fetchAllProperties = async () => {
        const response = await apiFetch('/api/Property/all');
        const data = await response.json();
        if (data.success && data.data) {
            setAllProperties(data.data);
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            fetchChecklistData();
            fetchAllProperties();
        }, 0);
        return () => clearTimeout(timer);
    }, [user.userID]);

    const formatDate = (date) => {
        if (!date) return "";
        if (typeof date === "string") return date.split("T")[0];
        if (typeof date === "object" && date.year && date.month && date.day)
            return `${date.year}-${String(date.month).padStart(2, "0")}-${String(date.day).padStart(2, "0")}`;
        return date.toString();
    };

    const propertyIdToName = {};
    allProperties.forEach(p => {
        propertyIdToName[p.propertyID] = p.propertyName;
    });

    return (
        <div style={{ margin: "0 auto" }}>
            <h2>Daily Checklist Submissions</h2>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        <th>Submission ID</th>
                        <th>Created By User</th>
                        <th>Property</th>
                        <th>Checklist Completed</th>
                        <th>Submission Date</th>
                        <th>View</th>
                    </tr>
                </thead>
                <tbody>
                    {checklistData.map((submission) => (
                        <tr key={submission.submissionID}>
                            <td>{submission.submissionID}</td>
                            <td>{user.firstName} {user.lastName}</td>
                            <td>{propertyIdToName[submission.propertyID] || submission.propertyID}</td>
                            <td>{submission.checklistCompleted ? "Yes" : "No"}</td>
                            <td>{formatDate(submission.submissionDate)}</td>
                            <td>
                                <span
                                    data-tooltip-id={`view-tooltip-${submission.submissionID}`}
                                    style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
                                >
                                    View
                                </span>
                                <ReactTooltip
                                    id={`view-tooltip-${submission.submissionID}`}
                                    place="right"
                                    effect="solid"
                                    clickable={true}
                                    style={{ whiteSpace: "pre-line" }}
                                >
                                    <div style={{ minWidth: 250 }}>
                                        {submission.responses && submission.responses.length > 0 ? (
                                            <table style={{ width: "100%", fontSize: "1.2em" }}>
                                                <thead>
                                                    <tr>
                                                        <th>Question</th>
                                                        <th>Answer</th>
                                                        <th style={{ paddingLeft: "16px" }}>Comment</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {submission.responses.map((resp, idx) => (
                                                        <tr key={idx}>
                                                            <td>{resp.questionText || <i>Unknown</i>}</td>
                                                            <td>{resp.check ? "Yes" : "No"}</td>
                                                            <td>{resp.comment || "-"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div>No responses</div>
                                        )}
                                    </div>
                                </ReactTooltip>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default DailyCheckList;